import React from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/system';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import {concatUrl} from './helpers/url';
import history from './helpers/history';
import {postCall} from './helpers/request';
import GlobalContext from './helpers/context';
import {ROOT_PATH} from './settings';


const LoginComponent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 100
});

const AvatarComponent = styled(Avatar)(({ theme }) =>({
    margin: 30,
    backgroundColor: theme.palette.secondary.main
}));

const FormTitleComponent = styled(Typography)(({ theme }) =>({
    marginBottom: 40,
    fontSize: 24
}));

const LoginFormComponent = styled('form')({
    maxWidth: 300
});

const FormControlComponent = styled(FormControl)(({ theme }) =>({
    minWidth: 150,
    marginBottom: 30,
    fontSize: theme.custom.font.medium
}));

const ErrorMessageComponent = styled(Typography)(({ theme }) =>({
    color: red[700],
    fontWeight: theme.custom.font.bold,
    textAlign: 'center'
}));

const ButtonComponent = styled(Button)({
    marginTop: 30
});


class LoginForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            login_error: null,
            username: '',
            password: '',
            form_errors: {}
        };

        this.form_data = {};

        this.login_url = concatUrl(window.ROOT_URL, 'api', 'login');

    }

    loginFailed = () => {
        this.context.displayGlobalError('Backend service failure: Login service is not working.');
    };

    loginDone = (data, callback_failure) => {
        if(data) {
            if (!data.user) {
                this.setState({login_error: 'Login failed'});
            } else {
                this.props.callback(data);
                history.push(ROOT_PATH);
                document.location.reload();
            }
        }else{
            callback_failure();
        }
    };

    formValidated = () => {
        let form_errors = {
            'username': this.state.username.length === 0 ? 'Please enter a username' : null,
            'password': this.state.password.length === 0 ? 'Please enter a password' : null
        };
        this.form_data = {
            username: this.state.username,
            password: this.state.password
        };

        this.setState({
            login_error: null,
            form_errors: form_errors
        });
        let form_is_valid = true;
        /*eslint-disable no-unused-vars */
        for (let key in form_errors){
            if (form_errors[key]){
                form_is_valid = false;
                break;
            }
        }
        /*eslint-enable no-unused-vars */
        return form_is_valid;
    };

    login = () => {
        if (this.formValidated()){
            postCall(this.login_url, this.form_data, this.loginDone, this.loginFailed);
        }
    };

    showErrorMessage = (key) => {
        if (key in this.state.form_errors && this.state.form_errors[key]) {
            return (
                <ErrorMessageComponent data-bt={`error_${key}`}>
                    {this.state.form_errors[key]}
                </ErrorMessageComponent>
            );
        }
    };

    errorMode = (key) => {
        return (key in this.state.form_errors && this.state.form_errors[key] !== null);
    };

    submitOnEnter = (event) => {
        if(event.keyCode === 13){
            this.login();
        }
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <LoginComponent data-bt="login_page">
                    <AvatarComponent>
                        <LockOutlinedIcon />
                    </AvatarComponent>

                    <FormTitleComponent component="h1">
                        Sign in
                    </FormTitleComponent>

                    <LoginFormComponent>
                        <FormControlComponent fullWidth={true}>
                            <TextField
                                autoFocus
                                fullWidth
                                error={this.errorMode('username')}
                                variant="outlined"
                                id="username"
                                slotProps={{ htmlInput: {'data-bt': 'username'} }}
                                type="text"
                                label="Username"
                                InputLabelProps={{ shrink: true }}
                                autoComplete="username"
                                onKeyDown={this.submitOnEnter}
                                value={this.state.username}
                                onChange={(event) => {this.setState({username: event.target.value})}}
                            />
                            {this.showErrorMessage('username')}
                        </FormControlComponent>

                        <FormControlComponent fullWidth={true}>
                            <TextField
                                fullWidth
                                error={this.errorMode('password')}
                                variant="outlined"
                                id="password"
                                slotProps={{
                                    htmlInput: {'data-bt': 'password'},
                                    inputLabel: {'shrink': true},
                                }}
                                type="password"
                                label="Password"
                                autoComplete="password"
                                onKeyDown={this.submitOnEnter}
                                value={this.state.password}
                                onChange={(event) => {this.setState({password: event.target.value})}}
                            />
                            {this.showErrorMessage('password')}
                        </FormControlComponent>

                        {this.state.login_error && <ErrorMessageComponent data-bt="error_login">{this.state.login_error}</ErrorMessageComponent>}

                        <ButtonComponent
                            fullWidth
                            data-bt="login_button"
                            variant="contained"
                            color="primary"
                            onClick={this.login}>
                            Sign in
                        </ButtonComponent>
                    </LoginFormComponent>
                </LoginComponent>
            )}
            </GlobalContext.Consumer>
        );
    }
}

LoginForm.contextType = GlobalContext;

LoginForm.propTypes = {
    callback: PropTypes.func
};

export default LoginForm;